import { useAppStore } from '../../store/useAppStore'
import RecipeOfTheDay from '../../components/RecipeOfTheDay/RecipeOfTheDay'
import { StoriesTray } from '@widgets/stories'
import { RecentlyViewed } from '@widgets/recently-viewed'
import SearchBar from '../../components/SearchBar/SearchBar'
import SubscriptionBlock from '../../components/SubscriptionBlock/SubscriptionBlock'
import CoursesBlock from './components/CoursesBlock'
import FreeHomeContent from './components/FreeHomeContent'
import ScrollTopButton from './components/ScrollTopButton'
import SearchResults from './components/SearchResults'
import SectionCards from './components/SectionCards'
import ToolsBlock from './components/ToolsBlock'
import './HomePage.css'

/**
 * Главная: обложка рецепта дня, истории, поиск и блоки — разделы, курсы,
 * недавно просмотренное, полезные инструменты.
 *
 * Разделы с фильтрами переехали в «Базу»: на главной они дублировали теги и
 * занимали весь экран. Здесь от них остались карточки-входы.
 *
 * Новые блоки показываем только по подписке. Без неё разделы, поиск и недавнее
 * недоступны, блоки выходили пустыми — там остаётся прежняя главная с
 * доступным материалом, см. FreeHomeContent.
 */
const HomePage = () => {
  const { searchQuery, hasActiveSubscription, setSearchQuery } = useAppStore()
  const hasSubscription = hasActiveSubscription()
  const isSearching = searchQuery.trim().length > 0

  return (
    <div className="homepage">
      <RecipeOfTheDay hasSubscription={hasSubscription} />

      <StoriesTray />

      {hasSubscription ? (
        <>
          <SearchBar placeholder="Поиск" onSearch={setSearchQuery} />

          {/* Пока ищут, блоки прячем: иначе результат теряется среди них. */}
          {isSearching ? (
            <SearchResults query={searchQuery} />
          ) : (
            <>
              <SectionCards />
              <CoursesBlock />
              <RecentlyViewed />
              <ToolsBlock />
            </>
          )}
        </>
      ) : (
        <>
          <FreeHomeContent />
          <SubscriptionBlock hasSubscription={hasSubscription} />
        </>
      )}

      <ScrollTopButton />
    </div>
  )
}

export default HomePage
